import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppShell } from '@/components/AppShell';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { BOARDS_MODES } from '@/lib/tracks';
import { ArrowRight, BookText, TestTube } from 'lucide-react';

const ICONS = { BOARDS_THEORY: BookText, BOARDS_PRACTICAL: TestTube };

export default function BoardsModePage() {
  const nav = useNavigate();
  return (
    <AppShell>
      <div className="space-y-6" data-testid="boards-mode-page">
        <div>
          <div className="text-xs uppercase tracking-wide text-muted-foreground">Track</div>
          <h1 className="font-display text-3xl font-semibold">Boards</h1>
          <p className="mt-1 text-muted-foreground">Pick Theory or Practicals to continue.</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {BOARDS_MODES.map((m) => {
            const Icon = ICONS[m.key] || BookText;
            return (
              <Card
                key={m.key}
                className="transition-shadow hover:shadow-lg"
                data-testid={m.key === 'BOARDS_THEORY' ? 'boards-theory-card' : 'boards-practicals-card'}
              >
                <CardContent className="space-y-4 p-6">
                  <div className="flex items-center gap-3">
                    <div className="grid h-11 w-11 place-items-center rounded-lg bg-primary/10 text-primary">
                      <Icon className="h-6 w-6" />
                    </div>
                    <div className="font-display text-xl font-semibold">{m.title}</div>
                  </div>
                  <p className="text-sm text-muted-foreground">{m.desc}</p>
                  <Button className="w-full gap-1.5" onClick={() => nav(`/pick?track=${m.key}`)}>
                    Choose chapter <ArrowRight className="h-4 w-4" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
        <Button variant="ghost" onClick={() => nav('/dashboard')} data-testid="boards-back-button">
          ← Back
        </Button>
      </div>
    </AppShell>
  );
}
